import React, { useState } from 'react';
import { BankCredential, BankData } from '../../../types';
import { BankAccountForm } from './BankAccountForm';
import ProcessSuccessful from '../../../assets/icons/ProcessSuccessful';
import { SidebarDrawer, Button } from '../../common';

interface CreateProps {
  onCreate: (data: BankData) => void;
  showButton: boolean;
}

const CreateBankAccount: React.FC<CreateProps> = ({ onCreate }) => {
  const [showSuccessModal, setShowSuccessModal] = useState(false);

  const handleCreate = async (data: BankData) => {
    try {
      await onCreate(data);
      setShowSuccessModal(true);
    } catch (error) {
    } finally {
    }
  };

  const handleContinue = () => {
    setShowSuccessModal(false);
  };

  return (
    <>
      <BankAccountForm
        initialData={{
          bankName: '',
          accountNumber: '',
          accountName: '',
          isActive: true,
          currency: 'NGN',
        }}
        onSubmit={handleCreate} bankNameInput={''}      />

      {showSuccessModal && (
        <SidebarDrawer
          title="Your Bank Account has been saved"
          show={showSuccessModal}
          position="left"
          buttonText="Continue"
          children={<ProcessSuccessful />}
          onClick={handleContinue}
          showFooter={true}
        />
      )}
    </>
  );
};

export default CreateBankAccount;
